import { FC, ReactNode } from 'react';

interface ISlideActionsProps {
    children: ReactNode;
}

export const SlideActions: FC<ISlideActionsProps> = ({ children }) => {
    return (
        <div style={{display: 'flex', flexDirection: 'column', width: '100%', maxWidth: 400, textAlign: 'center'}}>
            {children}
        </div>
    );
};
